import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {IStickyHandler} from '../sticky-handler/sticky-handler.interface';
import {LobbyHeaderBox} from "./boxes/lobby-header.box";
import {LobbyHeaderTitleBox} from "./boxes/title/lobby-header-title.box";
import {LobbyHeaderLineBox} from "./boxes/line/lobby-header-line.box";
import classNames from 'classnames';
import {STICKY} from "../../themes/css-global-classes";
import {CyClass} from "../../../common/cy-classes";
import {FiltersMobileButtonComponent} from "../header/top-header-left/filters/filters-mobile-button.component";
import {LobbyHeaderButtonsContainerBox} from "./boxes/buttons/lobby-header-buttons-container.box";
import {LobbyHeaderButtonsBox} from "./boxes/buttons/lobby-header-button.box";
import {ThemeProvider} from "styled-components";
import { LobbyHeaderTitleContainerBox } from './boxes/title/lobby-header-title.container.box';

export interface LobbyHeaderComponentProps {
  stickyHandler: IStickyHandler;
  title: string;
  showSearchIcon: boolean;
}

@observer
export class LobbyHeaderComponent extends OrbitComponent<LobbyHeaderComponentProps> {

  private handleSearchClick = () => {
    this.services.gameSearch.openSearchResult();
  }

  render() {

    const isMobile = this.services.device.isMobile;
    const lobbyHeaderClasses = classNames('cy-lobby-header', {
      [STICKY]: this.props.stickyHandler.isSticky
    });

    const SearchIcon = this.services.theme.currentTheme.icons.searchIcon;

    return (
        <ThemeProvider theme={this.services.theme.currentTheme}>
          <LobbyHeaderBox className={lobbyHeaderClasses} stickOffset={this.services.header.headerHeight}>
            {this.props.title &&
              <LobbyHeaderTitleContainerBox>
                <LobbyHeaderTitleBox className={CyClass("cy-lobby-header-title")}>
                  {this.services.translation.translate(this.props.title)}
                </LobbyHeaderTitleBox>
                { isMobile && 
                  <LobbyHeaderButtonsContainerBox>
                  {
                    this.props.showSearchIcon &&
                    <LobbyHeaderButtonsBox>
                      <div onClick={this.handleSearchClick}>
                        <SearchIcon/>
                      </div>
                    </LobbyHeaderButtonsBox>
                  }
                  <FiltersMobileButtonComponent/>
                </LobbyHeaderButtonsContainerBox>
               }
              </LobbyHeaderTitleContainerBox>
            }
            {this.props.children}
            <LobbyHeaderLineBox></LobbyHeaderLineBox>
          </LobbyHeaderBox>
        </ThemeProvider>
    );
  }
}
